import { FC, useRef, useState } from 'react';

import { DeleteOutlined, CopyOutlined, QuestionCircleOutlined, SettingOutlined } from '@ant-design/icons';
import { Popconfirm, Tooltip } from 'antd';

import { formatMembershipSynced } from '../../../../helpers/utils/reports';

type Props = {
    nodeData: any
    confirmGroupRemoving: (nodeData: any) => void
    handleEditGroup: (nodeData: any) => void
    handleCreateGroupFromExisting?: (nodeData: any) => void
}

/**
 * Лист-группа «Группы регистраций» в дереве группировок.
 * Аналог MetricItem: при наведении показывает иконки копирования/редактирования/удаления.
 * Признак группы — dataKey вида custom_group_*.
 */
const GroupItem: FC<Props> = ({ nodeData, confirmGroupRemoving, handleEditGroup, handleCreateGroupFromExisting }) => {
    const isBlocked = useRef(false);
    const [ isHovered, setIsHovered ] = useState(false);

    const handleMouseLeave = () => {
        if (!isBlocked.current) {
            setIsHovered(false);
        }
    };

    const handleRemoveGroup = () => {
        confirmGroupRemoving(nodeData);
        isBlocked.current = false;
    };

    const handleRemoveGroupOpenChange = (open: boolean) => {
        isBlocked.current = open;
        setIsHovered(open);
    };

    // Компактная метка «когда связь группы последний раз пересобиралась».
    const synced = formatMembershipSynced(nodeData?.membership_synced_at);

    return (
        <span
            className="group-item-icon-wrapper"
            onMouseEnter={() => setIsHovered(true)}
            style={{
                display: 'flex',
                color: 'black',
                paddingLeft: '10px',
                justifyContent: 'space-between'
            }}
            onMouseLeave={handleMouseLeave}
        >
            <span>
                {nodeData.title}
                {nodeData.description && (
                    <span style={{ marginRight: 10, marginLeft: 5 }}>
                        <Tooltip
                            placement="bottom"
                            title={<div className="page-title-tooltip-text">{nodeData.description}</div>}
                            color="#fff"
                            zIndex={9999}
                            overlayClassName="page-title-tooltip"
                        >
                            <QuestionCircleOutlined style={{ color: '#ccc', fontSize: 16 }} />
                        </Tooltip>
                    </span>
                )}
                {synced ? (
                    <Tooltip title={`Связь группы пересобрана: ${synced.full}`} placement="top">
                        <span style={{ marginLeft: 6, color: '#bbb', fontSize: 11, whiteSpace: 'nowrap' }}>
                            ⟳ {synced.short}
                        </span>
                    </Tooltip>
                ) : (
                    <Tooltip title="Связь группы ещё ни разу не пересобиралась" placement="top">
                        <span style={{ marginLeft: 6, color: '#ccc', fontSize: 11, whiteSpace: 'nowrap' }}>
                            ⟳ —
                        </span>
                    </Tooltip>
                )}
            </span>

            {isHovered && (
                <span
                    className={'settings'}
                    style={{
                        marginRight: '5px',
                        display: 'inline-flex',
                        columnGap: '2px',
                        paddingLeft: '20px'
                    }}
                    onClick={(e) => e.preventDefault()}
                >
                    <CopyOutlined
                        onClick={() => handleCreateGroupFromExisting && handleCreateGroupFromExisting(nodeData)}
                        style={{
                            color: 'rgb(84 83 83)',
                            fontSize: 16,
                            width: '20px'
                        }}
                    />

                    <span
                        onMouseEnter={() => isBlocked.current = true}
                        onMouseLeave={() => isBlocked.current = false}
                    >
                        <SettingOutlined
                            onClick={() => handleEditGroup(nodeData)}
                            style={{
                                color: 'rgb(84 83 83)',
                                fontSize: 16,
                                width: '20px'
                            }}
                        />
                    </span>

                    <Popconfirm
                        title="Удалить?"
                        onConfirm={handleRemoveGroup}
                        okText="Да"
                        onOpenChange={handleRemoveGroupOpenChange}
                        cancelText="Нет"
                    >
                        <span>
                            <DeleteOutlined
                                style={{
                                    color: 'rgb(84 83 83)',
                                    fontSize: 16,
                                    width: '20px'
                                }}
                            />
                        </span>
                    </Popconfirm>
                </span>
            )}
        </span>
    );
};
export default GroupItem;
